export const isLanguageSupported = (code) => {
  return [
    "AR",
    "BG",
    "CS",
    "DA",
    "DE",
    "EL",
    "EN-GB",
    "EN-US",
    "ES",
    "ET",
    "FI",
    "FR",
    "HU",
    "ID",
    "IT",
    "JA",
    "KO",
    "LT",
    "LV",
    "NB",
    "NL",
    "PL",
    "PT-BR",
    "pt-PT",
    "RO",
    "RU",
    "SK",
    "SL",
    "SV",
    "TR",
    "UK",
    "ZH",
  ].includes(code);
};

export const isLanguageReferToAnother = (code) => {
  if (["SA"].includes(code)) return code;
  else return null;
};

export const getCountryCodeFromFlagPath = (flagPath) => {
  const splited = flagPath.split("/");
  return splited[splited.length - 1].split(".")[0].toUpperCase();
};

export const getTranslatedCode = (code) => {
  const translatedCode = {
    AE: "AR",
    AR: "AE",
    BG: "BG",
    CS: "CZ",
    CZ: "CS",
    DA: "DK",
    DK: "DA",
    DE: "DE",
    EL: "GR",
    GR: "EL",
    GB: "EN-GB",
    ["EN-GB"]: "GB",
    US: "EN-US",
    ["EN-US"]: "US",
    ES: "ES",
    ET: "EE",
    EE: "ET",
    FI: "FI",
    FR: "FR",
    HU: "HU",
    ID: "ID",
    IT: "IT",
    JA: "JP",
    JP: "JA",
    LT: "LT",
    LV: "LV",
    NB: "NO",
    NO: "NB",
    NL: "NL",
    PL: "PL",
    PT: "pt-PT",
    ["pt-PT"]: "PT",
    BR: "PT-BR",
    ["PT-BR"]: "BR",
    RO: "RO",
    RU: "RU",
    SK: "SK",
    SL: "SI",
    SI: "SL",
    SV: "SE",
    SE: "SV",
    TR: "TR",
    UK: "UA",
    UA: "UK",
    ZH: "CN",
    CN: "ZH",
    SA: "AR",
  };
  console.log(
    "inside =>",
    code.codePointAt(0).toString(16),
    code,
    typeof code,
    code === "BR",
    translatedCode[code.toString()]
  );

  return !translatedCode[code] ? code : translatedCode[code];
};
